import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export function FaqPreview() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);
  const preview = faqItems.slice(0, 4);

  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex items-center justify-between">
          <div>
            <span className="inline-flex rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900 whitespace-nowrap">
              常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              读者最常问的几件事
            </h2>
          </div>
          <a
            href="/faq"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-9 space-y-3">
          {preview.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200/80"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                    {item.question}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-7 text-foreground-700">
                    {item.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export function Cta() {
  return (
    <section className="relative w-full overflow-hidden bg-primary-500">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-16 -top-16 h-56 w-56 rounded-full bg-primary-300/30 blur-2xl"></div>
        <div className="absolute -bottom-20 right-0 h-64 w-64 rounded-full bg-accent-400/30 blur-2xl"></div>
      </div>
      <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-16 text-center md:px-6 md:py-20">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 ring-1 ring-background-50/30 whitespace-nowrap">
          <i className="ri-chat-smile-3-line"></i>
          一起继续挖掘伏笔
        </span>
        <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
          还有更多洞洞的秘密，等你一起来发现
        </h2>
        <p className="mt-4 max-w-2xl text-sm leading-7 text-background-100/90 md:text-base">
          无论是想补充你发现的隐藏线索，还是对某处设定有疑问，
          都可以联系我们。你的考据视角，也许就是下一个被写进百科的重要发现。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="/contact"
            className="inline-flex items-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100 whitespace-nowrap"
          >
            联系我们
            <i className="ri-mail-line"></i>
          </a>
          <a
            href="/faq"
            className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-medium text-background-50 ring-1 ring-background-50/40 transition-colors hover:bg-background-50/10 whitespace-nowrap"
          >
            先看常见问题
          </a>
        </div>
      </div>
    </section>
  );
}